<template>
  <v-container id="transfer-items">
    <v-data-table
      :headers="headers"
      :items="items"
      dense
      :hide-default-footer="true"
      :disable-sort="true"
      :hide-default-header="true"
    >
      <!-- Custom Header -->
      <template v-slot:header="{ props }">
        <thead>
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="custom-header"
              style=" border-bottom: thin solid rgb(0 0 0 / 0%);"
            >
              <p>{{ header.text }}</p>
            </th>
          </tr>
        </thead>
      </template>

      <!-- Body Rows -->
      <template v-slot:body="{ items }">
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <v-autocomplete
              v-model="item.product_id"
              :items="products"
              item-text="products.name"
              item-value="product_id"
              dense
              outlined
              clearable
              :rules="[rules.required]"
              placeholder="Product Code"
              @change="getBatches(item.product_id, item)"
              class="dropdown-spacing"
            ></v-autocomplete>
          </td>
          <td>
            <v-autocomplete
              v-model="item.batch_id"
              :items="item.filProducts"
              item-text="batch.batch_code"
              item-value="batch_id"
              dense
              outlined
              clearable
              :rules="[rules.required]"
              placeholder="Batch Number"
              @blur="clearBatch()"
              @change="setProductCode(item.batch_id, item.filProducts, item)"
              class="dropdown-spacing"
            ></v-autocomplete>
          </td>

          <td>
            <v-text-field
              v-model.number="item.quantity"
              :rules="[
                () => validateQuantity(item),
                rules.required,
                rules.positive,
              ]"
              placeholder="Quantity"
              type="number"
              dense
              outlined
              clearable
              @blur="validateAndCorrect(item)"
            ></v-text-field>
          </td>
          <td class="pb-5">
            <v-icon
              size="30"
              color="red"
              @click="$emit('remove-item', index)"
              class="delete-icon"
            >
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-row class="mt-0">
      <v-col class="text-left">
        <v-icon size="40" color="blue" @click="$emit('add-item')"
          >mdi-plus</v-icon
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ItemsTable",
  props: {
    items: { type: Array, required: true },
    products: { type: Array, required: true },
    headers: {
      type: Array,
      default: () => [
        { text: "Product Code ", value: "product_code" },
        { text: "Batch Number", value: "batch_id" },
        { text: "Quantity", value: "quantity" },
        { text: "", value: "actions", sortable: false },
      ],
    },
    title: { type: String, default: "Items" },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "This field is required.",
        positive: (value) => value >= 0 || "Value cannot be negative.",
      },
      batches: [],
    };
  },
  methods: {
    clearBatch() {
      this.batches = [];
    },
    setProductCode(batch_id, filProducts, item) {
      const selectedProduct = filProducts.find(
        (product) => product.batch_id === batch_id
      );
      if (selectedProduct) {
        item.product_code = selectedProduct.products.product_code;
      } else {
        item.product_code = null; // Clear if no match
      }
    },

    getBatches(product_id, item) {
      // Get all selected batch_ids from the current items list
      const selectedBatchIds = this.items
        .filter((i) => i.product_id === product_id && i.batch_id) // Filter items with the same product_id and a batch selected
        .map((i) => i.batch_id);

      // Filter batches that haven't been selected yet
      item.filProducts = this.products.filter(
        (product) =>
          product.product_id === product_id &&
          !selectedBatchIds.includes(product.batch_id)
      );
    },

    validateQuantity(item) {
      const product = this.products.find(
        (p) => p.product_id === item.product_id && p.batch_id === item.batch_id
      );
      if (product && item.quantity > product.stock_in_hand_quantity) {
        return `Max quantity available: ${product.stock_in_hand_quantity}`;
      }
      return true;
    },

    validateAndCorrect(item) {
      const product = this.products.find(
        (p) => p.product_id === item.product_id && p.batch_id === item.batch_id
      );
      if (product && item.quantity > product.stock_in_hand_quantity) {
        item.quantity = product.stock_in_hand_quantity;
      }
    },
    updateItemDetails(item, selectedId) {
      const selectedProduct = this.products.find((p) => p.id === selectedId);

      if (selectedProduct) {
        item.id = selectedId;
        item.batch_id = selectedProduct.batch_id;
        item.product_id = selectedProduct.product_id;
      }
    },
  },
  created() {},
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: rgba(192, 0, 250, 0.215);
  border-radius: 10px;
}
.dropdown-spacing {
  margin-right: 30px;
}
</style>
